import {
  AvailableFws,
  DashCamList,
  ICameraInfo,
  IDashCamList,
  Webviewer,
} from '@thingsw/pitta-modules';
import _ from 'lodash';
import {
  useMemo,
  useEffect,
  useCallback,
  useState,
  useRef,
  RefObject,
} from 'react';
import { Index, List, ListRowRenderer } from 'react-virtualized';
import { CAMERA } from '../../features/Camera/slice';
import { ScrollBar } from '@thingsw/pitta-design-system';
import clsx from 'clsx';
import React from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { APP_MENU } from '../../screens/app/renewal2/RenewalMapviewScreen';
import { NoResults } from '../NoResults';
import { RenewalCameraItem } from '../renewal2/RenewalCameraItem';
import {} from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../features/store';
import { USER } from '../../features/User/slice';
import { GROUP } from '../../features/Group/slice';
import { makeStyles, Theme } from '@material-ui/core';
import { CameraGroupHeader } from './CameraGroupHeader';
import { THEME } from '../../features/Theme/slice';

const useStyles = makeStyles((theme: Theme) => ({
  topTransition: {
    transition: theme.transitions.create([
      'transform',
      'padding',
      'height',
      'top',
    ]),
  },
  cameraItem: {
    margin: '8px 16px',
    width: 'calc(100% - 32px) !important',
  },
  cameraItemGroup: {
    margin: '8px 10px',
    width: 'calc(100% - 20px) !important',
  },
  camDiv: {
    padding: '8px 0 0 0',
    height: 'calc(100% - 56px)',
    overflowY: 'auto',
    backgroundColor: (props: any) => props.colors.primary['0'],
    position: 'relative',
    borderRadius: 12,
  },
  camDivMobile: {
    height: '100%',
    width: '100%',
  },
  noResultDiv: {
    marginTop: '36vh',
    [theme.breakpoints.up(Webviewer.mobile)]: {
      marginTop: '29.5vh',
    },
  },
  container: {
    position: 'absolute',
    right: 0,
    left: 0,
    top: -8,
    boxShadow:
      'rgba(0, 0, 0, 0.12) -2px -2px 12px -4px, rgba(0, 0, 0, 0.16) 0px -2px 16px -4px',
    overflow: 'hidden',
  },
  lastContainer: {
    borderRadius: '0 0 8px 8px',
  },
  scrollbarsDiv: {
    '&>div': {
      marginBottom: '0!important',
    },
  },
}));

interface CameraListProps {
  handleMenu: (camera: ICameraInfo, menu: APP_MENU) => void;
  onClickDelete: (camera: ICameraInfo) => void;
  onClickManage: () => void;
  handleMore: (camera: ICameraInfo | undefined) => void;
  onClickLocation?: (camera: {
    device: ICameraInfo;
    groupManagementID?: string;
    groupName?: string;
    groupRegDT?: string;
  }) => void;
  searchKey: string;
  selectedGroups: string[];
  availableNewFws: AvailableFws;
  mobile?: boolean;
  buttonsRef: React.MutableRefObject<{
    [key: string]: RefObject<HTMLDivElement>;
  }>;
  isShowLocationIcon?: boolean;
  isMapView?: boolean;
}

export const CameraList = (props: CameraListProps) => {
  const {
    handleMenu,
    onClickDelete,
    onClickManage,
    handleMore,
    onClickLocation,
    searchKey,
    selectedGroups,
    availableNewFws,
    mobile,
    buttonsRef,
    isShowLocationIcon,
    isMapView,
  } = props;

  const { colors } = useSelector((state: RootState) => state[THEME]);

  const classes = useStyles({ colors });

  const listRef = useRef<List>(null);
  const simpleBarRef = useRef<any>(null);
  const camListRef = useRef<HTMLDivElement | null>(null);

  const { cameraList } = useSelector((state: RootState) => state[CAMERA]);
  const { userProfile } = useSelector((state: RootState) => state[USER]);
  const { groupsList } = useSelector((state: RootState) => state[GROUP]);

  const [searchGroupList, setSearchGroupList] = useState<IDashCamList>();

  const [topTransition, setTopTransition] = useState(false);
  const [openGroupList, setOpenGroupList] = useState<
    { id: string; height: number }[]
  >([]);

  const [fixedGroupHeader, setFixedGroupHeader] = useState<DashCamList>();
  const [fixedHeaderTop, setFixedHeaderTop] = useState(0);
  const [listWidth, setListWidth] = useState(375);

  const [groupIdList, setGroupIdList] = useState<string[]>([]);

  const renderingList = useMemo(() => {
    if (
      cameraList &&
      cameraList.deviceListInfo &&
      cameraList.deviceListInfo.length > 0
    ) {
      const notInGroup = _.includes(selectedGroups, 'notInGroup')
        ? _.chain(cameraList.deviceListInfo)
            .filter((camera) => {
              let show = false;

              if (isMapView && camera.device.reg_category === 'wifi') {
                return false;
              }

              if (searchKey) {
                show =
                  camera.device.dev_name
                    .toLowerCase()
                    .indexOf(searchKey.trim().toLowerCase()) > -1 ||
                  camera.device.model
                    .toLowerCase()
                    .indexOf(searchKey.trim().toLowerCase()) > -1;
              } else {
                show = true;
              }

              // mantis - 11501, Admin 계정은 그룹 내 캠리스트 출력되도록 수정 (Leehj)
              if (show && userProfile?.userType !== 'SubMaster') {
                const group = _.find(groupsList?.DashCamList, (g) => {
                  return _.find(
                    g.DashCamUser,
                    (d) => d.PSN === camera.device.psn
                  );
                });
                show = !group;
              }
              return show;
            })
            .compact()
            .map((d) => d.device)
            .value()
        : [];

      let searchedGroupNameList: string[] = [];

      const inGroup: DashCamList[] = _.chain(groupsList?.DashCamList)
        .filter((g) => _.includes(selectedGroups, g.GroupID))
        .reverse()
        .filter((g) => {
          if (searchKey) {
            if (
              g.GroupName.toLocaleLowerCase().indexOf(
                searchKey.trim().toLowerCase()
              ) > -1
            ) {
              searchedGroupNameList.push(g.GroupName);
              return true;
            }

            if (isMapView && g.DashCamUser && g.DashCamUser.length > 0) {
              _.find(g.DashCamUser, (d) => {
                const cam = _.find(
                  cameraList.deviceListInfo,
                  (dev) => dev.device.psn === d.PSN
                );

                if (cam?.device.reg_category === 'wifi') {
                  return false;
                }
              });
            }

            return !!_.find(g.DashCamUser, (d) => {
              const cam = _.find(
                cameraList.deviceListInfo,
                (dev) => dev.device.psn === d.PSN
              );
              return (
                cam &&
                (cam.device.dev_name
                  .toLowerCase()
                  .indexOf(searchKey.trim().toLowerCase()) > -1 ||
                  cam.device.model
                    .toLowerCase()
                    .indexOf(searchKey.trim().toLowerCase()) > -1)
              );
            });
          } else {
            return true;
          }
        })
        .filter((group) => {
          if (group.DashCamUser && group.DashCamUser.length > 0 && group) {
            return true;
          }
          return false;
        })
        .compact()
        .value();

      const groups: any[] = [];
      for (let grp of inGroup) {
        groups.push(grp);
        if (_.find(openGroupList, (g) => g.id === grp.GroupID)) {
          for (let cam of grp.DashCamUser ?? []) {
            if (searchKey) {
              if (
                cam.DashCamName.toLowerCase().indexOf(
                  searchKey.trim().toLowerCase()
                ) > -1 ||
                searchedGroupNameList.includes(grp.GroupName)
              ) {
                groups.push(cam);
              }
            } else {
              groups.push(cam);
            }
          }
        }
      }

      return [
        ...notInGroup,
        ...(userProfile?.userType === 'Master' ? groups : []),
      ];
    }
    return [];
  }, [
    cameraList,
    groupsList?.DashCamList,
    isMapView,
    openGroupList,
    searchKey,
    selectedGroups,
    userProfile?.userType,
  ]);

  // 그룹이 갱신 될 때만 searchGroupList를 갱신
  useEffect(() => {
    if (!groupsList || !groupsList?.DashCamList) return;

    let newGroupId = false;

    groupsList?.DashCamList.forEach((g) => {
      if (!_.includes(groupIdList, g.GroupID)) {
        newGroupId = true;
      }
    });

    if (newGroupId) {
      setSearchGroupList(groupsList);
      setGroupIdList(_.map(groupsList?.DashCamList, (g) => g.GroupID));
    }
  }, [groupIdList, groupsList]);

  useEffect(() => {
    const filteredGroup = _.chain(searchGroupList?.DashCamList)
      .filter((g) => _.includes(selectedGroups, g.GroupID))
      .compact()
      .value();

    filteredGroup.forEach((g) => {
      let match = false;

      g.DashCamUser?.forEach((cam) => {
        if (
          searchKey &&
          cam.DashCamName.toLocaleLowerCase().indexOf(
            searchKey.trim().toLowerCase()
          ) > -1
        ) {
          match = true;
          setOpenGroupList((s) =>
            _.chain([...s, { id: g.GroupID, height: 0 }])
              .compact()
              .uniqBy('id')
              .value()
          );
        }

        if (searchKey && !match) {
          setOpenGroupList((s) =>
            _.differenceBy(s, [{ id: g.GroupID, height: 0 }], 'id')
          );
        }
      });
    });
  }, [groupIdList, searchGroupList?.DashCamList, searchKey, selectedGroups]);

  useEffect(() => {
    if (!searchKey) {
      setOpenGroupList([]);
    }
  }, [searchKey]);

  // console.log('searchKey', 'renderingList', renderingList);

  useEffect(() => {
    // console.log(
    //   'rowHeight',
    //   'listRef.current?.Grid?.forceUpdate',
    //   camListRef.current?.clientHeight
    // );
    listRef.current?.recomputeRowHeights();
  }, [renderingList]);

  const calculatedHeights = useMemo(() => {
    return _.map(renderingList, (r, index) => {
      if (r.GroupID) {
        const found = _.find(openGroupList, (g) => g.id === r.GroupID);
        if (found) {
          return 118;
        }
        return 126;
      } else {
        const psn = r.psn || r.PSN;
        const height = _.find(openGroupList, (g) => g.id === psn)?.height ?? 0;

        const group = _.chain(renderingList)
          .slice(0, index)
          .findLast((r) => !!r.GroupID)
          .value();

        const filteredDashCamUser = _.filter(group?.DashCamUser, (cam) => {
          if (searchKey) {
            if (
              cam.DashCamName.toLowerCase().indexOf(
                searchKey.trim().toLowerCase()
              ) > -1
            ) {
              return true;
            }
            return false;
          }
          return true;
        });

        const last =
          _.findIndex(filteredDashCamUser, (d) => d.PSN === psn) ===
          (filteredDashCamUser.length ?? 1) - 1;

        if (r.PSN) {
          // return 210 + height;
        }

        return 226 + height + (last ? 8 : 0);
      }
    });
  }, [openGroupList, renderingList, searchKey]);

  const rowHeight = useCallback(
    (indx: Index) => {
      return calculatedHeights[indx.index];
    },
    [calculatedHeights]
  );

  const rowRenderer: ListRowRenderer = useCallback(
    (props) => {
      const { index, style, key } = props;
      const item = renderingList[index];
      const camera = item as any;

      if (camera.GroupID) {
        const opened = !!_.find(openGroupList, (g) => g.id === camera?.GroupID);
        // console.log(
        //   'rowRenderer',
        //   'camera.GroupName',
        //   camera.GroupName,
        //   'opened',
        //   opened
        // );
        return (
          <div
            key={key}
            style={{ ...style, width: 'calc(100% - 8px)', left: 4, right: 4 }}
            className={clsx({ [classes.topTransition]: topTransition })}
            onTransitionEnd={() => setTopTransition(false)}
          >
            <CameraGroupHeader
              group={camera}
              mobile={mobile}
              onClose={() => {
                setOpenGroupList((s) =>
                  _.differenceBy(s, [{ id: camera.GroupID, height: 0 }], 'id')
                );
              }}
              onOpen={() => {
                setOpenGroupList((s) =>
                  _.chain([...s, { id: camera.GroupID, height: 0 }])
                    .compact()
                    .uniqBy('id')
                    .value()
                );

                //스크롤 위치 계산
                const pos = _.chain(calculatedHeights)
                  .slice(0, index)
                  .sum()
                  .value();
                // console.log('pos', pos);
                setTimeout(() => {
                  simpleBarRef.current?.scrollTop(pos);
                }, 100);
              }}
              initialOpen={opened}
            />
          </div>
        );
      } else {
        const psn = camera.PSN || camera.psn;
        const found = _.find(
          cameraList?.deviceListInfo,
          (dev) => dev.device.psn === psn
        )?.device;
        const fw = _.find(availableNewFws, (v, k) => k === found?.psn);

        if (!found) return;

        const group = _.chain(renderingList)
          .slice(0, index)
          .findLast((r) => !!r.GroupID)
          .value();

        const filteredDashCamUser = _.filter(group?.DashCamUser, (cam) => {
          if (searchKey) {
            if (
              cam.DashCamName.toLowerCase().indexOf(
                searchKey.trim().toLowerCase()
              ) > -1
            ) {
              return true;
            }
            return false;
          }
          return true;
        });

        const last =
          _.findIndex(filteredDashCamUser, (d) => d.PSN === psn) ===
          (filteredDashCamUser.length ?? 1) - 1;

        const open = !!(
          _.find(openGroupList, (g) => g.id === psn)?.height ?? 0
        );

        return (
          <div
            key={key}
            style={{ ...style, display: 'block', overflow: 'hidden' }}
            className={clsx({ [classes.topTransition]: topTransition })}
            onTransitionEnd={() => setTopTransition(false)}
          >
            <div
              style={{
                ...(camera.PSN
                  ? { margin: '8px 16px', background: colors.primary['5'] }
                  : {}),
              }}
              className={clsx({
                [classes.container]: camera.PSN,
                [classes.lastContainer]: last,
              })}
            >
              <RenewalCameraItem
                onClickLocation={() =>
                  onClickLocation?.({
                    device: found,
                  })
                }
                handleOpenPanel={({ psn, height }) => {
                  if (height === 0) {
                    setOpenGroupList((s) =>
                      _.differenceBy(s, [{ id: psn, height }], 'id')
                    );
                  } else {
                    setOpenGroupList((s) => {
                      console.log(
                        'calculatedHeights',
                        _.chain([...s, { id: psn, height }])
                          .compact()
                          .uniqBy('id')
                          .value()
                      );
                      return _.chain([...s, { id: psn, height }])
                        .compact()
                        .uniqBy('id')
                        .value();
                    });
                  }
                }}
                isWifiCamera={found.reg_category === 'wifi'}
                className={clsx({
                  [classes.cameraItem]: !!camera.psn,
                  [classes.cameraItemGroup]: !!camera.PSN,
                })}
                camera={found}
                ref={buttonsRef.current[found.psn]}
                newFw={!!(fw?.blackvue || fw?.dmc200)}
                onClickMore={() => {
                  handleMore(found);
                }}
                onClickManage={onClickManage}
                onClickDelete={onClickDelete}
                handleMenu={(menu) => handleMenu(found, menu)}
                initialOpen={open}
                isShowLocationIcon={isShowLocationIcon}
              />
            </div>
          </div>
        );
      }
    },
    [
      availableNewFws,
      buttonsRef,
      calculatedHeights,
      cameraList?.deviceListInfo,
      classes.cameraItem,
      classes.cameraItemGroup,
      classes.container,
      classes.lastContainer,
      classes.topTransition,
      colors.primary,
      handleMenu,
      handleMore,
      isShowLocationIcon,
      mobile,
      onClickDelete,
      onClickLocation,
      onClickManage,
      openGroupList,
      renderingList,
      searchKey,
      topTransition,
    ]
  );

  const cameraListVirtualizedMarkup = useMemo(() => {
    if (renderingList.length > 0) {
      return (
        <div
          ref={(ref) => {
            camListRef.current = ref;
            setListWidth(ref?.clientWidth ?? 375);
          }}
          className={clsx(classes.camDiv, {
            [classes.camDivMobile]: mobile,
          })}
          style={{ overflow: 'hidden', padding: 0 }}
        >
          {fixedGroupHeader && (
            <div
              style={{
                position: 'absolute',
                top: fixedHeaderTop,
                right: 4,
                left: 4,
                width: 'calc(100% - 8px)',
                zIndex: 999,
                backgroundColor: colors.primary['0'],
              }}
            >
              <CameraGroupHeader
                group={fixedGroupHeader}
                mobile={mobile}
                onClose={() => {
                  setOpenGroupList((s) =>
                    _.differenceBy(
                      s,
                      [{ id: fixedGroupHeader.GroupID, height: 0 }],
                      'id'
                    )
                  );
                  setFixedGroupHeader(undefined);
                  setFixedHeaderTop(0);
                  listRef.current?.forceUpdate();
                }}
                onOpen={() => {
                  // setOpenGroupList((s) =>
                  //   _.chain([...s, { id: fixedGroupHeader.GroupID, height: 0 }])
                  //     .compact()
                  //     .uniqBy('id')
                  //     .value()
                  // );
                  // //스크롤 위치 계산
                  // const pos = _.chain(calculatedHeights)
                  //   .slice(0, index)
                  //   .sum()
                  //   .value();
                  // // console.log('pos', pos);
                  // setTimeout(() => {
                  //   simpleBarRef.current?.scrollTop(pos);
                  // }, 100);
                }}
                initialOpen
              />
            </div>
          )}
          <Scrollbars
            onScroll={(e) => {
              if (listRef.current) {
                //@ts-ignore
                const { scrollTop, scrollLeft } = e.target;
                const { Grid } = listRef.current;
                Grid?.handleScrollEvent({
                  scrollTop: scrollTop + 100,
                  scrollLeft,
                });
              }
              let ccTop = 0;
              const currentTop = simpleBarRef.current?.getScrollTop() ?? 0;
              let vv = 0;
              for (let indx = 0; indx < calculatedHeights.length; indx++) {
                ccTop += calculatedHeights[indx];
                if (ccTop < currentTop) {
                  vv = indx + 1;
                } else {
                  break;
                }
              }

              // vv앞에 그룹 헤더가 있는지 확인
              const group = _.chain(renderingList)
                .slice(0, vv + 1)
                .findLast((r) => !!r.GroupID)
                .value();
              const opened = !!_.find(
                openGroupList,
                (g) => g.id === group?.GroupID
              );

              const item = renderingList[vv];
              const item2 = renderingList[vv + 1];
              const psn = item?.psn || item?.PSN;
              const psn2 = item2?.psn || item2?.PSN;
              const last1 =
                _.findLastIndex(group?.DashCamUser, (d) => d.PSN === psn) ===
                (group?.DashCamUser?.length ?? 1) - 1;
              const last2 =
                _.findLastIndex(group?.DashCamUser, (d) => d.PSN === psn2) ===
                (group?.DashCamUser?.length ?? 1) - 1;

              const p = _.chain(calculatedHeights)
                .slice(0, vv + 1)
                .sum()
                .value();

              // console.log(
              //   'scrollTop',
              //   'groupHeader',
              //   group,
              //   'last1',
              //   last1,
              //   'last2',
              //   last2
              // );
              if (opened && !last1) {
                const topOffset = p - (currentTop + 118);
                setFixedGroupHeader(group);
                if (last2) {
                  if (topOffset < 0) {
                    setFixedHeaderTop(topOffset);
                  } else {
                    setFixedHeaderTop(0);
                  }
                } else {
                  setFixedHeaderTop(0);
                }
              } else {
                setFixedGroupHeader(undefined);
                setFixedHeaderTop(0);
              }
            }}
            style={{
              height: camListRef.current?.clientHeight ?? '100%',
              width: camListRef.current?.clientWidth ?? 375,
              padding: '12px 0',
              marginBottom: 0,
            }}
            className={clsx({ [classes.scrollbarsDiv]: mobile })}
            autoHide
            ref={simpleBarRef}
          >
            <List
              ref={listRef}
              width={listWidth}
              height={
                camListRef.current?.clientHeight ?? 500
                // Math.min(3 * 220, filteredCams.length * 220)
                // cameraCardExtraHeight.reduce((acc, cur) => acc + cur.height, 0)
              }
              overscanRowCount={10}
              rowHeight={rowHeight}
              rowCount={renderingList.length}
              rowRenderer={rowRenderer}
              style={
                mobile ? {} : { overflowY: 'visible', overflowX: 'visible' }
              }
              onScroll={({ scrollTop }) => {
                handleMore(undefined);

                let ccTop = 0;
                const currentTop = scrollTop;
                let vv = 0;
                for (let indx = 0; indx < calculatedHeights.length; indx++) {
                  ccTop += calculatedHeights[indx];
                  if (ccTop < currentTop) {
                    vv = indx + 1;
                  } else {
                    break;
                  }
                }

                // vv앞에 그룹 헤더가 있는지 확인
                const group = _.chain(renderingList)
                  .slice(0, vv + 1)
                  .findLast((r) => !!r.GroupID)
                  .value();
                const opened = !!_.find(
                  openGroupList,
                  (g) => g.id === group?.GroupID
                );

                const item = renderingList[vv];
                const item2 = renderingList[vv + 1];
                const psn = item?.psn || item?.PSN;
                const psn2 = item2?.psn || item2?.PSN;
                const last1 =
                  _.findLastIndex(group?.DashCamUser, (d) => d.PSN === psn) ===
                  (group?.DashCamUser?.length ?? 1) - 1;
                const last2 =
                  _.findLastIndex(group?.DashCamUser, (d) => d.PSN === psn2) ===
                  (group?.DashCamUser?.length ?? 1) - 1;

                const p = _.chain(calculatedHeights)
                  .slice(0, vv + 1)
                  .sum()
                  .value();

                // console.log(
                //   'scrollTop',
                //   'groupHeader',
                //   group,
                //   'last1',
                //   last1,
                //   'last2',
                //   last2
                // );
                if (opened && !last1) {
                  const topOffset = p - (currentTop + 118);
                  setFixedGroupHeader(group);
                  if (last2) {
                    if (topOffset < 0) {
                      setFixedHeaderTop(topOffset);
                    } else {
                      setFixedHeaderTop(0);
                    }
                  } else {
                    setFixedHeaderTop(0);
                  }
                } else {
                  setFixedGroupHeader(undefined);
                  setFixedHeaderTop(0);
                }
              }}
            />
          </Scrollbars>
        </div>
      );
    }
    if (!searchKey) {
      return (
        <div ref={camListRef} className={classes.camDiv}>
          <ScrollBar simpleBarRef={simpleBarRef}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            ></div>
          </ScrollBar>
        </div>
      );
    }
    return (
      <div className={classes.noResultDiv}>
        <NoResults />
      </div>
    );
  }, [
    calculatedHeights,
    classes.camDiv,
    classes.camDivMobile,
    classes.noResultDiv,
    classes.scrollbarsDiv,
    colors.primary,
    fixedGroupHeader,
    fixedHeaderTop,
    handleMore,
    listWidth,
    mobile,
    openGroupList,
    renderingList,
    rowHeight,
    rowRenderer,
    searchKey,
  ]);

  return cameraListVirtualizedMarkup;
};
